var _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActiveDot(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#31c369",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    opacity: 0.3,
    r: 6.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 4.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDot);
export default ForwardRef;